var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.778 0C14.555 0 16 1.346 16 3v6c0 1.654-1.445 3-3.222 3H12v1c0 1.654-1.445 3-3.222 3H3.222C1.445 16 0 14.654 0 13V7c0-1.654 1.445-3 3.222-3H4V3c0-1.654 1.445-3 3.222-3h5.556ZM4 6h-.778C2.549 6 2 6.448 2 7v6c0 .552.549 1 1.222 1h5.556C9.452 14 10 13.552 10 13v-1H7.222C5.445 12 4 10.654 4 9V6Zm8.778-4H7.222C6.548 2 6 2.448 6 3v6c0 .552.548 1 1.222 1h5.556C13.451 10 14 9.552 14 9V3c0-.552-.549-1-1.222-1ZM10 3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0V7H8a1 1 0 1 1 0-2h1V4a1 1 0 0 1 1-1Z",
    id: "newwindow_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#newwindow_svg__a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab);
export default __webpack_public_path__ + "static/media/NewTab.c27f37548a930b8ece3862cdd214c4e3.svg";
export { ForwardRef as ReactComponent };